(async () => {
  const [
    React,
    ReactDOM,
    { default: App }
  ] = await Promise.all([
    import('react'),
    import('react-dom'),
    import('./index')
  ]);

  ReactDOM.render(
    <App />,
    document.getElementById('app')
  );
})();
